import { useSyncedPref } from './useSyncedPref';

/** Contabile defaults to the Italian date format when no preference is set. */
export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';

export function useDateFormat() {
  const [dateFormat] = useSyncedPref('dateFormat');
  return dateFormat || DEFAULT_DATE_FORMAT;
}
